// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.paraswap",
    name: "ParaSwap Wallet",
    homepage: "https://paraswap.io",
    image_id: "73dc6b30-b644-46e6-020c-5926851df600",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/paraswap-multichain-wallet/id1584610690",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "paraswap://",
        universal: "https://wallet.paraswap.io/#/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map